// extracted by mini-css-extract-plugin
export var displayNone = "_oj-6";
export var imgContainer = "_oj-2";
export var overflowHidden = "_oj-3";
export var productInfoCardButtonContainer = "_oj-5";
export var productTitleText = "_oj-4";
export var rightArrow = "_oj-1";
export var rightArrowContainer = "_oj-0";